<template>
  <div class="navigation-bar text-center">
    <div
      class="scrollmenu d-flex align-items-center pr-5"
      tabindex="0"
      style="overflow-x: auto; white-space: nowrap; outline: none"
    >
      <div v-for="(item, index) in menuItems" :key="index" class="market-games d-inline-block">
        <router-link :to="item.route" @click="handleSportClick(item)">
          <span class="icon">
            <img
              :src="getImageSrc(item.icon)"
              :alt="`Icon for ${item.title}`"
              @error="setFallbackImage($event)"
            />
          </span>
          <span class="icon-title">{{ item.title }}</span>
          <div v-if="item.new" class="spec-icon hot">New</div>
        </router-link>
      </div>
    </div>

    <div class="market-games d-inline-block">
      <a href="#" style="border-left: 1px solid #152638" @click.prevent="menuStore.openSportsMenu">
        <span class="icon"
          ><img
            :src="getImageSrc('/assets/images/backup/side-menu.svg')"
            alt="Open more menu options"
        /></span>
        <span class="icon-title">More</span>
      </a>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useSportStore } from '@/stores/sport.js'
import { useMenuStore } from '@/stores/menu.js'

export default {
  name: 'TopNav',
  setup() {
    const sportStore = useSportStore()

    const menuItems = ref([
      {
        id: 2,
        title: 'Soccer',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/icon_soccer.svg',
        route: { name: 'sport', params: { sport_name: 'Football' } },
        new: false
      },
      {
        id: 3,
        title: 'Aviator',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/icon_aviator.svg',
        route: { name: 'aviator' },
        new: false
      },
      {
        id: 9,
        title: 'Jackpot',
        icon: 'https://storage.googleapis.com/maybet/site/2025/icons/MB8.png',
        route: { name: 'jackpot' },
        new: true
      },
      {
        id: 4,
        title: 'Ligi Soo',
        icon: 'https://storage.googleapis.com/maybet/site/2025/icons/LIGISoo3.png',
        route: { name: 'ligi' },
        new: false
      },
      {
        id: 8,
        title: 'EPL',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/icon-EPL.png',
        route: { name: 'epl' },
        new: false
      },
      {
        id: 29,
        title: 'MSL',
        icon: 'https://storage.googleapis.com/maybet/site/2025/icons/SUPER_LEAGUEwhite.webp',
        route: { path: 'msl' },
        new: false
      },
      {
        id: 10,
        title: 'Crash',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/old/icon_crash-games.svg',
        route: { name: 'crashgames' },
        new: false
      },
      {
        id: 6,
        title: 'Virtuals',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/icon_virtual_token.svg',
        route: { name: 'virtualgames' },
        new: false
      },
      {
        id: 7,
        title: 'Casino',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/icon_casino.svg',
        route: { name: 'casino' },
        new: false
      },
      {
        id: 5,
        title: 'Bet Hub',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/bethub.svg',
        route: { name: 'codehub' },
        new: true
      },
      {
        id: 11,
        title: 'Spin2Win',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/old/icon_spin2win.svg',
        route: { name: 'spin2win' },
        new: false
      },
      {
        id: 14,
        title: 'App',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/icon-app-interface.svg',
        route: { name: 'app' },
        new: false
      },
      {
        id: 15,
        title: 'ESoccer',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/old/box.svg',
        route: { name: 'sport', params: { sport_name: 'ESoccer' } },
        new: false
      },
      {
        id: 13,
        title: 'JetX',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/old/icon_jet-x.svg',
        route: { name: 'jetx' },
        new: false
      },
      {
        id: 16,
        title: 'Basketball',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/old/sport-icon-basketball.svg',
        route: { name: 'sport', params: { sport_name: 'Basketball' } },
        new: false
      },
      {
        id: 17,
        title: 'Tennis',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/sport-icon-tennis2.svg',
        route: { name: 'sport', params: { sport_name: 'Tennis' } },
        new: false
      },
      {
        id: 18,
        title: 'Volleyball',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/sport-icon-volleyball.svg',
        route: { name: 'sport', params: { sport_name: 'Volleyball' } },
        new: false
      },
      {
        id: 19,
        title: 'Rugby',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/sport-icon-rugby.svg',
        route: { name: 'sport', params: { sport_name: 'Rugby' } },
        new: false
      },
      {
        id: 20,
        title: 'Handball',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/icon_handball2.svg',
        route: { name: 'sport', params: { sport_name: 'Handball' } },
        new: false
      },
      {
        id: 21,
        title: 'Boxing',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/sport-icon-boxing2.svg',
        route: { name: 'sport', params: { sport_name: 'Boxing' } },
        new: false
      },
      {
        id: 22,
        title: 'Baseball',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/sport-icon-baseball-ball.svg',
        route: { name: 'sport', params: { sport_name: 'Baseball' } },
        new: false
      },
      {
        id: 23,
        title: 'NFL',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/icon_americanfootball2.svg',
        route: { name: 'sport', params: { sport_name: 'NFL' } },
        new: false
      },
      {
        id: 24,
        title: 'IceHockey',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/sport-icon-ice-hockey2.svg',
        route: { name: 'sport', params: { sport_name: 'IceHockey' } },
        new: false
      },
      {
        id: 25,
        title: 'MMA',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/icon_mma2.svg',
        route: { name: 'sport', params: { sport_name: 'MMA' } },
        new: false
      },
      {
        id: 25,
        title: 'Cricket',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/cricket.svg',
        route: { name: 'sport', params: { sport_name: 'Cricket' } },
        new: false
      },
      {
        id: 26,
        title: 'Badminton',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/icon_badminton.svg',
        route: { name: 'sport', params: { sport_name: 'Badminton' } },
        new: false
      },
      {
        id: 27,
        title: 'Darts',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/icon_darts2.svg',
        route: { name: 'sport', params: { sport_name: 'Darts' } },
        new: false
      },
      {
        id: 28,
        title: 'Promotions',
        icon: 'https://storage.googleapis.com/maybet/site/assets/icons/Icon_promotions2.svg',
        route: '/promos',
        new: false
      }
    ])

    const handleSportClick = (item) => {
      sportStore.updateSportId(item.id)
    }

    const getImageSrc = (src) => {
      return src
    }

    const setFallbackImage = (event) => {
      event.target.src = '/assets/images/backup/sport-icon-soccer.svg'
    }

    const menuStore = useMenuStore()

    return {
      menuItems,
      handleSportClick,
      getImageSrc,
      setFallbackImage,
      menuStore
    }
  }
}
</script>

<style scoped>
.scrollmenu {
  overflow-x: auto;
  white-space: nowrap;
  outline: none;
}

.market-games {
  display: inline-block;
}
</style>
